export default "__VITE_PUBLIC_ASSET__0781bd96__"